/**
 * Keep the service worker's controllerchange from reloading the page through
 * a paid AI stream (the Stage 4 photo assignment). The bootstrap installs
 * `__QM_BEGIN_PAID_AUTHORING__`; without it the lease is a no-op. Moved from
 * the deleted Work Method hook (use-wms-generation.ts,
 * docs/old-pipeline-removal/PLAN.md).
 */
export function acquirePaidAuthoringRuntimeLease(): () => void {
    if (typeof window === 'undefined') return () => {};
    const begin = (window as typeof window & {
        __QM_BEGIN_PAID_AUTHORING__?: () => (() => void);
    }).__QM_BEGIN_PAID_AUTHORING__;
    if (typeof begin !== 'function') return () => {};
    const release = begin();
    return typeof release === 'function' ? release : () => {};
}
